<style scoped lang="less">
    .singleRowProduct-module{
        
        .product-list{
            .product-item{
                
                background: #fff;

                &:last-child{
                    margin-bottom: 0;
                }

                .name{
                    margin: 10px 10px 5px;
                    font-size: 14px;
                    
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }

            }
            
        }
        .video-box{
            position: relative;

            .coverImage{
                position: absolute;
                left:0;
                top:0;
                width: 100%;
                height: 100%;
            }
        }
        
    }
    .haveSpace{
        margin-bottom: 10px;
    }
</style>

<template>
    <div class="singleRowProduct-module"  @mouseenter="data.visible=true" @mouseleave="data.visible=false" style="position: relative;padding-left: 40px;padding-right: 45px;" :class="{haveSpace: !data.hideSpace}">
        <module-name :name="name"></module-name>
        <controler @edit="edit();data.editVisible=true" @moveUp="$emit('moveUp')" :visible="data.visible" @moveDown="$emit('moveDown')" @remove="$emit('remove')" ></controler>
        <!-- <edit :data="data" @submit="$emit('submit')" :visible="data.editVisible" :name="name" @close="data.editVisible=false"  /> -->
        
        <div>
            <div class="product-list" v-if="videoUrl===''">
                <div class="product-item">
                    <img style="display: block;width: 100%;" :src="normalData.url" />
                    <!-- <p class="name">{{normalData.name}}</p> -->
                </div>
            </div>
            <div class="product-list" v-else>
                <div class="product-item">
                    <div class="video-box">
                        <video width="100%" style="vertical-align:top" :src="videoUrl" controls="controls">
                        您的浏览器不支持 video 标签。
                        </video>
                        <img class="coverImage" v-if="data.coverImage!==''" :src="$store.state.pageManageConfig.imghost+data.coverImage" />
                    </div>
                </div>
            </div>
        </div>

		<div class="cover" v-if="data.visible" style="position: absolute;left:40px;top:0;right: 45px;height: 100%;border: 3px solid #0000FF;"></div>
    </div>
</template>

<script>

import moduleName from '../../moduleName';
import controler from '../../controler';
import edit from './edit';
import config from '@/config/index'


export default {
    name: 'normal-module',
    components: {
        moduleName,
        controler,
        edit,
        
    },
    props: {
        name: {
            type: String,
            default: ''
        },
        data: {
            type: Object,
            default: ()=>{
                return {}
            }
        },
        
    },
    data () {
        return {
            normalData: {
                url: this.$store.state.pageManageConfig.staticImage.noVideo,
                name: '此处是视频标题-此处是视频标题',
            },
			imgUrl: config.IMG_BASE,
        };
    },
	computed:{
		videoUrl(){
			if (this.data.videoType == 1 && this.data.videoUrl){
				return this.imgUrl + this.data.videoUrl;
			}
			if (this.data.videoType == 2 && this.data.customVideoUrl){
				return this.data.customVideoUrl;
			}
			return ''
		}
	},
    methods: {
        edit(){
            this.$emit('visibleChange', this.data.visible)
        },
        
        close(){
            this.$emit('visibleChange', false)
        }

    },
    mounted () {
    },
    watch: {
        
    }
};
</script>

